import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toArray } from '../common/util';
import FlipMove from 'react-flip-move';
import { Waypoint } from 'react-waypoint';
import {fetchResources,} from '../redux/actions';
import {resourceSelector} from "../redux/selectors";
import DKPResourceItem from './DKPResourceItem';


class DKPResources extends Component {
    constructor(props) {
        super(props);
        this.handleUpdate= this.handleUpdate.bind(this);
    }

    componentDidMount() {
        this.props.getResources(this.props.chapter.id, this.props.dkp.slug);
    }

    handleUpdate() {
        if (!this.props.resources.pending && this.props.resources.more) {
            this.props.getResources(this.props.chapter.id, this.props.items.page)
        }
    }

    render() {
        const resourceItems = toArray(this.props.resources.data).filter((resource) => resource.section === this.props.dkp.id)
            .sort((a, b) => a.category.localeCompare(b.category))
            .filter((value, index, self) => self.map(x => x.category).indexOf(value.category) === index)
            .map((res, i) => (
                <div>
                    { res.category ? (
                    <div key={`${i}-resource-cat`} className="panel-adt">
                        <h2>{res.category}</h2>
                    </div>
                    ) : (
                    <div key={`${i}-resource-cat`} className="panel-adt">
                        <h2>Uncategorized</h2>
                    </div>
                    )
                    }
                
                    
                    {toArray(this.props.resources.data)
                        .filter((resource) => resource.section === this.props.dkp.id)
                        .filter((resource) => resource.category === res.category)
                        .sort((a, b) => a.title.localeCompare(b.title))
                        .map((resource, i) => (
                        <div key={`${i}-location`} className="panel-adt">
                            <DKPResourceItem resource={resource} />
                        </div>
                    ))}
                </div>    
        ));
        return (
            <div>
                <FlipMove
                    staggerDelayBy={50}
                    appearAnimation="fade"
                    enterAnimation="fade"
                    leaveAnimation="fade"
                    className="news"
                >
                    {resourceItems}
                </FlipMove>
                <div>
                    <Waypoint
                        key="waypoint"
                        onEnter={this.handleUpdate}
                        bottomOffset='-10%'
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    resources: resourceSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getResources: (chapter, section) => dispatch(fetchResources(chapter, section)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DKPResources);


// WEBPACK FOOTER //
// ./src/DKP/DKPResources.js